import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";

const goalSchema = z.object({
  start_date: z.string().date(),
  total_sales_goal: z.number(),
  ad_spend_goal: z.number(),
});
const categoryGoalSchema = goalSchema.extend({
  category_id: z.number(),
});
export type OrgGoal = z.infer<typeof goalSchema>;
export type CategoryGoal = z.infer<typeof categoryGoalSchema>;

export const goalsApiDefinitions = prefixApi(
  "/goals",
  apiBuilder({
    alias: "getOrgGoals",
    method: "get",
    path: "/org",
    parameters: [
      {
        name: "start_date",
        type: "Query",
        schema: z.string().date(),
      },
      {
        name: "end_date",
        type: "Query",
        schema: z.string().date(),
      },
      {
        name: "market_place",
        type: "Query",
        schema: z.string(),
      },
    ],
    status: 200,
    response: goalSchema.array(),
  })
    .addEndpoint({
      alias: "getCategoryGoals",
      method: "get",
      path: "/category",
      parameters: [
        {
          name: "start_date",
          type: "Query",
          schema: z.string().date(),
        },
        {
          name: "end_date",
          type: "Query",
          schema: z.string().date(),
        },
        {
          name: "market_place",
          type: "Query",
          schema: z.string(),
        },
      ],
      status: 200,
      response: categoryGoalSchema.array(),
    })
    .addEndpoint({
      alias: "setOrgGoals",
      method: "post",
      path: "/org",
      parameters: [
        {
          name: "body",
          type: "Body",
          schema: goalSchema
            .extend({
              market_place: z.string(),
            })
            .array(),
        },
      ],
      status: 204,
      response: z.void(),
    })
    .addEndpoint({
      alias: "setCategoryGoals",
      method: "post",
      path: "/category",
      parameters: [
        {
          name: "body",
          type: "Body",
          schema: categoryGoalSchema.array(),
        },
      ],
      status: 204,
      response: z.void(),
    })

    .build(),
);
